import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment-timezone'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import NavMenu from '../sidebar/navBar'; 
import SideMenu from '../sidebar/SidebarCustom'; 
import { adminGetInTouchListAction,sendContactUsReplayeAction } from '../../../actions/Admin/ContactUs.js';
import { appConstants } from '../../../_constants'
import './../App.css';
import { notification } from 'antd';

class AdminGetInTouchContactList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            messageViewModal: false,
            message:"",
            sendMesaageModalOpen: false,
            fieldsList: [],
            replayeMessage: '',
            sizePerPage: 10,
            page:0,
            fieldSelct: '',
            fieldsCount: "",
            contactUsMessage: "",
            mailTo:""
           
        };
        this.listRequest=this.listRequest.bind(this)
        this.contactUSReply=this.contactUSReply.bind(this)
        this.sendMessage=this.sendMessage.bind(this)
        this.openMesaageView=this.openMesaageView.bind(this)
    }

    componentWillMount() {
        let reqObj = {
            "limit": this.state.sizePerPage,
            "offset": 0,
            "order": "createdAt",
            "direction": "desc",
            "search": "",
            "status": ""

        }
        this.props.adminGetInTouchListAction(reqObj);
    }

    listRequest=(page,limit)=>{

        console.log("page,limit", page,limit);

          let reqObj = {
            "limit": limit,
            "offset": page,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""

        }
        this.props.adminGetInTouchListAction(reqObj);
    }

    componentWillReceiveProps(nextProps) {
        console.log("nextProps", nextProps.responseMail);
        if (nextProps &&  nextProps.userData&&nextProps.userData.data&&nextProps.userData.data.length > 0) {
            console.log("nextProps.userData.data", nextProps.userData.data);
            this.setState({
                fieldsCount: nextProps.userData.count,
                fieldsList: nextProps.userData.data

            })
        }        

        if (nextProps &&  nextProps.responseMail&&nextProps.responseMail.statusCode===200&&this.state.sendMailreq) {
            
             notification.success({
                message: nextProps.responseMail.msg,
                className:'successNotification',
                duration: 3
            });

            this.setState({
                sendMailreq: false,
                messageViewModal: false,
                sendMesaageModalOpen: false,
                message:"",
                mailTo:""


            })
        }
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    messageType = (e) => {
        e.preventDefault();
        console.log(e.target.name,e.target.value)
        this.setState({ message: e.target.value });
    }

    messageModal = () => {
        if(this.state.messageViewModal){
            this.setState({
                sendMesaageModalOpen:false
            })
        }
        this.setState({ messageViewModal: !this.state.messageViewModal });
    }

    contactUSReply = () => {
        this.setState({ sendMesaageModalOpen: !this.state.sendMesaageModalOpen });
    }    

    sendMessage = () => {
        let _this=this;
        if(_this.state.message !==""){
            let reqObj={
                userEmail:this.state.mailTo,
                message:this.state.message
            }
            _this.setState({ sendMailreq:true });
            _this.props.sendContactUsReplayeAction(reqObj);
        }
    }

    formatDate(iso_date) {
        if (typeof iso_date === 'undefined') {
            return moment().tz().format(appConstants.DATEFORMATNOTTIME);
        }
        return new Date(iso_date).toLocaleDateString("en-US");
    }

    onGetProjectSEDate(cell, row, rowIndex) {
        if (row && row.updatedAt) {
            return (this.formatDate(row.updatedAt))
        } else {
            return <span>-</span>
        }
    } 

    openMesaageView =(row,message)=>{
        this.setState({
            mailTo:row.email,
            contactUsMessage:row.message,
            messageViewModal:true
        })
    }

    onGetActionButton(cell, row, rowIndex) {
        if (row ) {
            return <button className="button-clicks" onClick={this.openMesaageView.bind(this,row)}>View Message</button>
        } else {
            return <span>-</span>
        }
    }
   

    sizePerPageListChange(sizePerPage) {

        this.setState({
            sizePerPage:sizePerPage
        })

        this.listRequest(this.state.page,sizePerPage);
    }

    onPageChange(page, sizePerPage) {
        this.setState({
            page:page,
            sizePerPage:sizePerPage
        }) 
        this.listRequest(page,sizePerPage);
    }


    render() { 
        const { fieldsList,sizePerPage,page,sendMesaageModalOpen } = this.state;
        var options = {
            onPageChange: this.onPageChange.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            sizePerPage:sizePerPage,
            page:page,
            paginationPosition: 'bottom', 
            alwaysShowAllBtns: true,
            prePage: 'Prev', 
            nextPage: 'Next', 
            firstPage: 'First', 
            lastPage: 'Last',
        };
  
        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    <div className="custom-table-wrapper">
                        <BootstrapTable data={fieldsList} options={options} remote={true} fetchInfo={{dataTotalSize: this.state.fieldsCount}}   pagination={ true }> 
                            <TableHeaderColumn width='230' hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                            <TableHeaderColumn width='500' tdAttr={{'data-attr':'Email' }} dataField='email'>Email</TableHeaderColumn>
                            <TableHeaderColumn width='350' tdAttr={{'data-attr':'Date' }} dataField='createdAt' dataFormat={this.onGetProjectSEDate.bind(this)}>Date</TableHeaderColumn>
                            <TableHeaderColumn  tdAttr={{'data-attr':'Action' }} dataField='' dataFormat={this.onGetActionButton.bind(this)}>Action</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>

                <Modal backdrop="static" keyboard={false} isOpen={this.state.messageViewModal} toggle={this.messageModal} className={this.props.className}>
                <ModalHeader toggle={this.messageModal}>Message</ModalHeader>
                    <ModalBody className="rep">
                        {this.state.contactUsMessage}
                        <br/>
                        {sendMesaageModalOpen&&
                           
                            <textarea name="message" className="m-admimreply" onChange={this.messageType.bind(this)} value={this.state.message}></textarea> 
                        }
                    </ModalBody> 

                <ModalFooter>
                {sendMesaageModalOpen&&
                    <Button type="submite" onClick={this.sendMessage}> Send Message</Button>
                }
                {!sendMesaageModalOpen&&
                    <Button type="info" onClick={this.contactUSReply}>Reply</Button>
                }
                    <Button type="cancel" onClick={this.messageModal}>Cancel</Button>
                </ModalFooter>
                </Modal>  

          
            </div> 


        );
    }
}



function mapStateToProps(state) {
    console.log("state", state.ContactUsAdmin.response);
    return {
        responseMail:state.ContactUsAdmin.responseMail,
        userCount: state.ContactUsAdmin.response.count,
        userData: state.ContactUsAdmin.response.data

    };
}


export default withRouter(connect(mapStateToProps, {
    adminGetInTouchListAction,
    sendContactUsReplayeAction
})(AdminGetInTouchContactList));





// WEBPACK FOOTER //
// ./src/components/Admin/Contact/GetInTouchContact.js